export const traverseAndFlatten = (currentNode, target, flattenedKey) => {
    for (let key in currentNode) {
        if (currentNode.hasOwnProperty(key)) {
            let newKey;
            if (flattenedKey === undefined) {
                newKey = key;
            } 
            else {
                newKey = key;
            }

            let value = currentNode[key];
            if (typeof value === "object") {
                traverseAndFlatten(value, target, newKey);
            } else {
                target[newKey] = value;
            }
        }
    }
}


export const gridValues = (label, options = []) => {
      let gridValues = {
        web : null,
        mobile : null
      }
      let labelLength = label ? label.length : Math.max(...(options?.map(option => option?.label?.length))) ;
      if(window.innerWidth > 750){
           if(labelLength< 7){
            gridValues.web = 6;
            gridValues.mobile = 6;
           } else{
            gridValues.web = 12;
            gridValues.mobile = 12;
           }
      }else{
        gridValues.web = 12;
        gridValues.mobile = 12;
      }

    return gridValues;
}